import { markRaw } from 'vue';
import UserModalBodyItem from '@/components/elements/UserModalBodyItem';
import ObjectsModalBodyItem from '@/components/elements/ObjectsModalBodyItem';

export const MODALS_DATA = {
  USERS: {
    title: <h3 class="modal__title">Пользователи</h3>,
    button: <button className="action-item tooltip__list-item-img--edit"
  aria-describedby="modal"/>,
    body: markRaw(UserModalBodyItem),
  },
  OBJECTS: {
    title: <h3 class="modal__title">Информация о подрядчике</h3>,
    button: <button className="action-item tooltip__list-item-img--edit"
  aria-describedby="modal"/>,
    body: markRaw(ObjectsModalBodyItem),
  },
};

// eslint-disable-next-line no-return-assign
export const MODALS = { ...MODALS_DATA };

Object.keys(MODALS).forEach((key) => {
  MODALS[key] = key;
});
